'use client';

import './VetRxDetails.scss';

import { useState, type MouseEvent } from 'react';
import {
    Button,
    Drawer,
    Heading,
    IconMediaBlock,
    Row,
    TextPassage,
} from '@petsmart-ui/sparky';
import type { VetRxCats } from '@app/pdp/types';
import { Locale, getLocale } from '@libs/core';
import { getIcon, getText, getDrawerHeader } from '@app/pdp/utils';
import type { Entry } from '@libs/contentful';
import VetRxDetailsBody from './VetRxDetailsBody';

export default function VetRxDetails({
    categories,
    vetRx,
}: {
    categories: VetRxCats[];
    vetRx: Entry<{ title: string }>[];
}) {
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const [catName, setCatName] = useState<VetRxCats | null>(null);

    const openDrawer = (e: MouseEvent<HTMLButtonElement>, cat: VetRxCats) => {
        e.preventDefault();
        setCatName(cat);
        setIsDrawerOpen(true);
    };

    const closeDrawer = () => {
        setCatName(null);
        setIsDrawerOpen(false);
    };

    return getLocale() === Locale['en-US'] ? (
        <Row
            xAlign="space-between"
            className="vet-rx-details"
            data-testid="test-vet-rx-details"
        >
            {categories.map(cat => (
                <IconMediaBlock
                    className="vet-rx__vet-rx-line"
                    key={cat}
                    iconSize="md"
                    verticalAlign="center"
                    iconName={getIcon(cat)}
                    variant="bare"
                >
                    <TextPassage>
                        <span>{getText(cat)} </span>
                        <Button
                            variant="link"
                            text="Details"
                            onClick={(e: MouseEvent<HTMLButtonElement>) =>
                                openDrawer(e, cat)
                            }
                        />
                    </TextPassage>
                </IconMediaBlock>
            ))}

            <Drawer
                className="vet-rx__drawer"
                isActive={isDrawerOpen}
                onClose={closeDrawer}
                align="right"
                ariaLabelledBy="drawer-heading"
                data-testid="vet-rx-drawer"
            >
                <Drawer.Header>
                    <Heading
                        id="drawer-heading"
                        className="vet-rx__drawer-heading"
                        tagName="h2"
                    >
                        {getDrawerHeader(catName)}
                    </Heading>
                </Drawer.Header>
                <Drawer.Body>
                    <VetRxDetailsBody cat={catName} vetRx={vetRx} />
                </Drawer.Body>
            </Drawer>
        </Row>
    ) : null;
}
